//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * A built-in GLSL floating-point constant for one solar radius.\n\
 *\n\
 * @alias czm_solarRadius\n\
 * @glslConstant\n\
 *\n\
 * @see CesiumMath.SOLAR_RADIUS\n\
 *\n\
 * @example\n\
 * // GLSL declaration\n\
 * const float czm_solarRadius = ...;\n\
 */\n\
const float czm_solarRadius = 695500000.0;\n\
";
